import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import AdapterLink from '../../links/modules/AdapterLink'
import ExternalLink from '../../links/modules/ExternalLink'
import Modal from '../../modals/modules/Modal'
import ModalDrawer from '../../modals/modules/ModalDrawer'

import { extension } from '../../requests/api'

import FileIcon from './FileIcon'

import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'

const styles = (theme) => {
    return {
        iconBtn: {
            padding: 0
        },
    }
}

class FileViewerButton extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            anchorEl: null,
            open: false
        }
    }
    handleClick(e,id) {
        e.preventDefault()
        this.setState({currentId:id,anchorEl:e.currentTarget,open:true})
    }
    handleClose() {
        this.setState({currentId:null,anchorEl:null,open:false})
    }
    render() {
        const filename = this.props.hasOwnProperty('filename')
            ? this.props.filename
            : ""
        let ext = this.props.hasOwnProperty('ext')
            ? this.props.ext
            : ""
        if( !ext && filename ) ext = extension(filename)
        const mime_type = this.props.hasOwnProperty('mime_type')
            ? this.props.mime_type
            : ""
        const anchor = this.props.hasOwnProperty('anchor')
            ? this.props.anchor
            : "right"
        const content = this.props.hasOwnProperty('content')
            ? this.props.content
            : null
        const title = this.props.hasOwnProperty('title')
            ? this.props.title
            : "View file"
        const size = this.props.hasOwnProperty('size')
            ? this.props.size
            : "small"

        const {classes} = this.props

        const contextMenu = this.props.hasOwnProperty('contextMenu')
            ? this.props.contextMenu
            : []
        const withContextMenu = contextMenu.length > 0 ? true : false
        const id = this.props.hasOwnProperty('id')
            ? ('context-menu-'+this.props.id)
            : null
        let contextMenuProps = {}
        if( withContextMenu && id !== null ) {
            contextMenuProps['id'] = id
            contextMenuProps['aria-controls'] = id
            contextMenuProps['onContextMenu'] = (e) => this.handleClick(e,id)
        }

        const Trigger = this.props.hasOwnProperty('Trigger')
            ? this.props.Trigger
            : null
        const TriggerComponent = !Trigger
            ? <IconButton title={title}
                size={size}
                className={classes.iconBtn}
                {...contextMenuProps}
            >
                <FileIcon mime_type={mime_type} ext={ext} />
            </IconButton>
            : (React.isValidElement(Trigger)
                ? React.cloneElement(
                    Trigger,
                    {...contextMenuProps}
                )
                : <Trigger {...contextMenuProps} />)

        const type = this.props.hasOwnProperty('type') ? this.props.type : 'modal'//modal|drawer
        const screenProps = this.props.hasOwnProperty('screenProps')
            ? this.props.screenProps
            : {fullScreen: true}

        const open = this.state.open
        const anchorEl = this.state.anchorEl
        return <React.Fragment>
            {type === 'drawer'
                ? <ModalDrawer
                    printCloseBtn
                    anchor={anchor}
                    ModalProps={screenProps}
                    title={title}
                    content={content}
                    Trigger={TriggerComponent}
                />
                : <Modal {...screenProps}
                    title={title}
                    content={content}
                    Trigger={TriggerComponent}
                />}
            {withContextMenu
                ? <Menu open={open}
                    id={"btn-"+id}
                    anchorEl={anchorEl}
                    onClose={() => this.handleClose()}
                >
                    {contextMenu.map((item,i) => {
                        const header = item.header
                        const Icon = item.icon
                        const target = item.target
                        const Component = target === 'external' ? ExternalLink : AdapterLink
                        const link = item.link
                        const disabled = item.disabled
                        return <MenuItem key={i} component={Component} to={link} target={target} disabled={disabled} onClick={() => this.handleClose()}>
                            <ListItemIcon><Icon fontSize="small" /></ListItemIcon>
                            <ListItemText>{header}</ListItemText>
                        </MenuItem>
                    })}
                </Menu>
                : null}
        </React.Fragment>
    }
}

export default withStyles(styles)(FileViewerButton)